if (!customElements.get('pdp-capp')) {
  customElements.define(
    'pdp-capp',
    class PDPCApp extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        var section_id = this.dataset.sectionId;

        this.lazy_el = document.querySelector(`lazy-section#${section_id}`);

        if (!this.lazy_el) return;

        this.base = this.dataset.base;
        this.collectionId = this.dataset.coll;
        this.productId = this.dataset.prod;
        this.isStack = this.hasAttribute('data-stack');

        if (!this.base || !this.collectionId || !this.productId) return;

        //use data to get current varaitn
        var current_color = this.dataset.currentColor;
        var initial_variant_index = this.dataset.initialIndex;

        this.setLazySectionParameter(current_color, initial_variant_index);

        this.colour_index = parseInt(this.dataset.colorIndex);

        //if capp has already loaded (comb listing)
        // trigger change with new product data
        this.triggerBaseChange(); //trigger base change on load for pdp

        //user changes main product variant
        //document.body outlives this element, so tie the listener to its life
        this.listeners = new AbortController();
        document.body.addEventListener(
          'variantChange',
          this.handleVariantChange.bind(this),
          { signal: this.listeners.signal },
        );
      }

      disconnectedCallback() {
        this.listeners?.abort();
      }

      handleVariantChange(e) {
        //dont do this in capp as there might be variantChange events within quick add popup
        var variant = e.detail.currentVariant;
        var all_variants = e.detail.variantData;

        if (!variant || !all_variants) return;

        var new_variant_index = all_variants.findIndex(
          (item) => item.id == variant.id,
        );

        if (new_variant_index < 0) return;

        this.variant_index = new_variant_index;

        //stack holds the pdp product in charm slot 0, so re-add it there —
        //setBaseIndex writes a base slot that stack never reads
        if (this.isStack) {
          this.triggerBaseChange();
        } else {
          document.body.dispatchEvent(
            new CustomEvent('cappSetBaseVariant', {
              detail: { variantIndex: new_variant_index },
            }),
          );
        }

        if (isNaN(this.colour_index)) return;
        var new_variant_tone = variant.options[this.colour_index];

        document.body.dispatchEvent(
          new CustomEvent('cappSetTone', {
            detail: { tone: new_variant_tone },
          }),
        );
        //change lazy section params, handle change before
        this.setLazySectionParameter(new_variant_tone, new_variant_index);
      }

      //change lazy-section params
      setLazySectionParameter(tone, variant_index) {
        var search_param = this.isStack
          ? this.getStackAppParams(tone, variant_index)
          : this.getCreateAppParams(tone, variant_index);

        this.tone = tone;
        this.variant_index = variant_index;

        this.lazy_el.dataset.params = search_param + '&update_url=false';
      }

      getCreateAppParams(tone, variant_index) {
        var search_param = `tone=${tone}&base=${this.base}&base-coll=${this.collectionId}&base-prod=${this.productId}&base-var=${variant_index}`;
        return search_param;
      }
      getStackAppParams(tone, variant_index) {
        var search_param = `tone=${tone}&base=${this.base}&charms[0][coll-id]=${this.collectionId}&charms[0][prod-id]=${this.productId}&charms[0][var-id]=${variant_index}`;
        return search_param;
      }

      getBaseObject() {
        //stack has no base product — the pdp product is charm 0
        if (this.isStack) {
          return {
            type: 'charm',
            currentlySelected: false,
            product_id: this.productId,
            variant_index: this.variant_index,
            collection_key: this.collectionId,
            charm_index: 0,
          };
        }

        var obj = {
          type: 'base',
          currentlySelected: false,
          product_id: this.productId,
          variant_index: this.variant_index,
          collection_key: this.collectionId,
          save_current_charms: true,
        };

        return obj;
      }

      triggerBaseChange() {
        var base_obj = this.getBaseObject();

        document.body.dispatchEvent(
          new CustomEvent('cappSetBase', {
            detail: { obj: base_obj },
          }),
        );
      }
    },
  );
}
